import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';
import { CartItem } from '../../../models/cart-item.model';

@Component({
  selector: 'usb-ticket-item',
  templateUrl: './ticket-item.component.html',
  styleUrls: ['./ticket-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TicketItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;
  @Output() removeTicket = new EventEmitter<any>();

  getTicketStatusClass(statusId: number): string {
    const statusMap: { [key: number]: string } = {
      1: 'product-status-saved',
      2: 'product-status-reserved',
      3: 'product-status-locked',
      4: 'product-status-denied',
      5: 'product-status-cancelled',
      6: 'product-status-paid-agency',
      7: 'product-status-paid-provider',
      8: 'product-status-completed'
    };
    return statusMap[statusId] || '';
  }

  getTicketDisplayPrice(ticket: any): number {
    if ((ticket?.statusId || ticket?.status_id) === 5) {
      return 0;
    }
    if (ticket?.isPaidAgency || ticket?.isPaidProvider) {
      return ticket?.convertedAmounts?.netPriceAgent || ticket?.netPrice || 0;
    }
    return this.currency.transform(
      ticket?.netPriceAgent,
      ticket?.currency,
      this.currencyAgency?.code,
      this.currencies
    ) || 0;
  }

  onRemoveItem(item: any): void {
    this.removeTicket.emit(item);
  }
}
